export default __webpack_public_path__ + "static/media/blob2.a07396bc.svg";